import { render, staticRenderFns } from "./StandardBars.vue?vue&type=template&id=0592a798"
import script from "./StandardBars.vue?vue&type=script&lang=js"
export * from "./StandardBars.vue?vue&type=script&lang=js"
import style0 from "./StandardBars.vue?vue&type=style&index=0&id=0592a798&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0592a798')) {
      api.createRecord('0592a798', component.options)
    } else {
      api.reload('0592a798', component.options)
    }
    module.hot.accept("./StandardBars.vue?vue&type=template&id=0592a798", function () {
      api.rerender('0592a798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/progress-bars/Widgets/StandardBars.vue"
export default component.exports